module.exports = __webpack_public_path__ + "img/51.6df36891.jpg";